<template>
    <div class="white-rounded-box mb-7 h-fit">
        <div class="mx-7 mt-4">
            <div class="flex justify-between align-center mb-3">
                <h2 class="text-hint">Recommended ProPicks</h2>
                <button type="button" @click.prevent="onExpand" title="Expand ProPicks">
                    <svg-vue icon="maximize-solid" title="Maximize" class="h-5 w-5 fill-salesium-red" />
                </button>
            </div>
        </div>
        <div>
            <!-- TODO: limit number of pros when we have more specifications -->
            <a  v-if="pros.length > 5" class="text-lg md:text-xl mx-7 hover:cursor-pointer text-salesium-blue " aria-label="View all connected pros" @click.prevent="openAllRecommendedPros">View all ({{ pros.length }})</a>
            <div>
                <ProPick class="connected-pro" v-for="pro in firstFivePros" :key="pro.id" :pro="pro" />
            </div>
        </div>
    </div>
</template>

<script>
import ProPick from './ProPick.vue'
export default {
    // TODO: dynamically iterate through pro picks
    props: ['recommendedProPicks', 'pros'],
    methods: {
        openAllRecommendedPros(){
            this.$emit('openAllFeaturedProsModal', 'featured' );
        }
    },
    computed: {
        firstFivePros(){
            return this.pros.slice(0,5);
        }
    },
    components: {
        ProPick
    }
}
</script>
